/* eslint-disable react/prop-types */
/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-03-15 10:14:03
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-14 17:51:13
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  ModalProps,
  Row,
  Select,
} from 'antd'
import React, { ReactElement, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { insuranceCodeValue } from '../../../models/setting'
import {
  editMedicalSetting,
  getMedicalItem,
  getSystemList,
  selectInsuranceArray,
} from './TenentSettingSlice'
import 'moment/locale/zh-cn'
import locale from 'antd/es/date-picker/locale/zh_CN'
import { DateTimeFormatSimpleOnly } from '../../../models/datetime'
import moment from 'moment'
import { getInsuranceCodeAsync, getTenantDetail } from '../tenantSlice'
import { hilistLmtpricTypeOptions, ZHEJIANGhilistLmtpricTypeOptions } from '../../../models/tenantSetting'
const { Option } = Select

export interface SettingProps {
  tenantId: string
  id?: number
}

export const TenentSettingModal: React.FC<ModalProps & SettingProps> = ({
  tenantId,
  id,
  onOk,
  onCancel,
  visible,
}): ReactElement => {
  const dispatch = useDispatch<any>()

  const [form] = Form.useForm()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [checkTime, setCheckTime] = useState(false)

  const [loading, setLoading] = useState(false)

  const [status, setStatus] = useState(true)

  const [isFaceCall, setIsFaceCall] = useState(true)

  const [ybFaceRecognition, setYbFaceRecognition] = useState(false)

  const [insuranceCode, setInsuranceCode] = useState<insuranceCodeValue[]>([])

  const [insuranceCodeOptions, setInsuranceCodeOptions] = useState<any>([])

  const [isProvinceInsuranceStatus, setIsProvinceInsuranceStatus] = useState(
    false
  )

  const [tenant, setTenant] = useState<any>()

  const mastRule = [
    {
      required: true,
    },
  ]

  const layout = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 },
  }

  const FormatLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const loadingbtn = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }

  const disabledStartDate: any = (current: any) => {
    const vs = form.getFieldsValue()
    if (vs.endTime) {
      return current && current > moment(vs.endTime).endOf('day')
    }
  }

  const disabledEndDate = (current: any) => {
    const vs = form.getFieldsValue()
    if (vs.startTime) {
      return current && current < moment(vs.startTime).endOf('day')
    } else {
      return current && current < moment().endOf('day')
    }
  }

  useEffect(() => {
    if (visible) {
      dispatch(getSystemList(1)) // 启用开通险种
        .then(unwrapResult)
        .then((res: insuranceCodeValue[]) => {
          setInsuranceCode(res)
        })
      dispatch(getTenantDetail(tenantId))
        .then(unwrapResult)
        .then((tenant: any) => {
          setTenant(tenant)
          form.setFieldsValue({
            name: tenant.name,
            shortName: tenant.shortName,
          })
        })
    }
    return () => {
      form.resetFields()
    }
  }, [visible])

  useEffect(() => {
    if (id) {
      dispatch(getMedicalItem({ id, tenantId }))
        .then(unwrapResult)
        .then((res: any) => {
          form.setFieldsValue({
            ...res,
            endTime: moment(res.endTime),
            startTime: moment(res.startTime),
            insuranceOffsiteProvinceCode:
              res?.insuranceOffsiteProvinceCode != -1
                ? res?.insuranceOffsiteProvinceCode
                : '',
          })
          res.insuranceCode &&
            dispatch(getInsuranceCodeAsync(res.insuranceCode))
              .then(unwrapResult)
              .then((res: any) => {
                setInsuranceCodeOptions(res)
              })
          setStatus(res.status)
          setIsProvinceInsuranceStatus(res?.isProvinceInsurance != -1 ? res?.isProvinceInsurance :0)
          setIsFaceCall(res.isFaceCall)
          setYbFaceRecognition(res.ybFaceRecognition === 1)
        })
    }
  }, [id])

  useEffect(() => {
    if (checkTime) {
      form.setFieldsValue({
        endTime: moment(tenant.endTime),
        startTime: moment(tenant.startTime),
      })
    } else {
      form.setFieldsValue({
        endTime: '',
        startTime: '',
      })
    }
  }, [checkTime])

  useEffect(() => {
    if (!visible) {
      form.resetFields()
    }
  }, [visible])

  return (
    <Modal
      title={(id ? '修改' : '开通') + '医保险种'}
      visible={visible}
      width='900px'
      onOk={() => {
        form.submit()
        loadingbtn()
      }}
      onCancel={onCancel}
      confirmLoading={loading}
    >
      <Form
        {...layout}
        form={form}
        initialValues={{
          limitPriceCfg: 0,
        }}
        onFinish={async (vs) => {

          console.log(vs,"vs");

          const insuranceName =
            insuranceCode.find((v) => v.insuranceCode === vs.insuranceCode)
              ?.insuranceName || ''
          await dispatch(
            editMedicalSetting({
              ...vs,
              status: Number(status),
              isProvinceInsurance: Number(isProvinceInsuranceStatus),
              isFaceCall: Number(isFaceCall),
              ybFaceRecognition: Number(ybFaceRecognition),
              endTime: moment(vs.endTime).format(DateTimeFormatSimpleOnly),
              startTime: moment(vs.startTime).format(DateTimeFormatSimpleOnly),
              insuranceName,
              tenantId,
              id,
            })
          )
            .then(unwrapResult)
            .then(onOk)
        }}
      >
        <Row gutter={20}>
          <Col span={16}>
            <Form.Item name='name' label='机构名称' required {...FormatLayout}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='shortName' label='机构略称'>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='insuranceCode' label='开通险种'>
              <Select
                onChange={(e) => {
                  console.log(e,"dddddddddd");
                  if(e == 'JIANGSU'){
                    form.setFieldsValue({
                      hilistLmtpricType:'99027'
                    })
                  }else{
                    form.setFieldsValue({
                      hilistLmtpricType: '',
                    })
                  }
                  e &&
                    dispatch(getInsuranceCodeAsync(e as string))
                      .then(unwrapResult)
                      .then((res: any) => {
                        setInsuranceCodeOptions(res)
                        form.setFieldsValue({
                          insuranceCuntryCode: '',
                        })
                      })
                }}
              >
                {insuranceCode.length &&
                  insuranceCode.map((v: insuranceCodeValue) => (
                    <Option value={v.insuranceCode} key={v.insuranceCode}>
                      {v.insuranceName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='secretToken'
              label='医保密钥'
              rules={[
                { required: true, message: '请输入医保密钥' },
                {
                  pattern: /^[a-zA-Z0-9#=|/-]*$/,
                  message: '请填写字母和数字',
                },
              ]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='cainfo'
              label='医保安全码'
              rules={[
                { message: '请输入医保安全码' },
                {
                  pattern: /^[a-zA-Z0-9#=|/-]*$/,
                  message: '请填写字母和数字',
                },
              ]}
            >
              <Input maxLength={300} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item name='startTime' label='功能服务起始时间'>
              <DatePicker
                locale={locale}
                format={DateTimeFormatSimpleOnly}
                disabledDate={disabledStartDate}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='endTime' label='功能服务结束时间'>
              <DatePicker
                locale={locale}
                format={DateTimeFormatSimpleOnly}
                disabledDate={disabledEndDate}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='' label='' noStyle>
              <Checkbox
                checked={checkTime}
                onChange={() => {
                  setCheckTime(!checkTime)
                }}
              >
                跟随租户服务时间设置
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='countryHospitalNb'
              label='医保国家机构编码'
              rules={[
                { required: true, message: '请输入医保国家机构编码' },
                {
                  pattern: /^[a-zA-Z0-9]*$/,
                  message: '请填写字母和数字',
                },
              ]}
            >
              <Input maxLength={32} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='cityHospitalNb' label='本地医保机构编码'>
              <Input maxLength={32} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='yidiHospitalNb' label='异地医保机构编码'>
              <Input maxLength={32} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='ybIp' label='医保指定的IP地址'>
              <Input maxLength={32} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='ybMac' label='MAC地址'>
              <Input maxLength={32} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='insuranceCuntryCode'
              label='医保行政区划'
              rules={mastRule}
            >
              {/*<Select>*/}
              {/*  {insuranceCodeOptions.length &&*/}
              {/*    insuranceCodeOptions.map((v: any) => (*/}
              {/*      <Option value={v.code} key={v.code}>*/}
              {/*        {v.name}*/}
              {/*      </Option>*/}
              {/*    ))}*/}
              {/*</Select>*/}
              <Input maxLength={6} />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              {...FormatLayout}
              name='hilistLmtpricType'
              label='医保目录限价类型'
              rules={mastRule}
            >
              <Select>
                {(form.getFieldValue('insuranceCode') == 'JIANGSU'
                  ? hilistLmtpricTypeOptions
                  : ZHEJIANGhilistLmtpricTypeOptions
                ).map((v: any) => (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='insruanceProvinceCode'
              label='省医保行政区划'
              rules={[{ required: isProvinceInsuranceStatus ? true : false }]}
            >
              <Input maxLength={6} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='insuranceOffsiteProvinceCode'
              label='省异地行政区划代码'
            >
              <Input maxLength={6} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item name='appId' label='电子处方应用ID'>
              <Input maxLength={64} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='appSecret' label='电子处方应用秘钥'>
              <Input maxLength={64} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='appPrivateKey' label='电子处方应用私钥'>
              <Input maxLength={64} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='platformPublicKey' label='电子处方平台公钥'>
              <Input maxLength={100} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col span={8}>
            <Form.Item name='' label='开通省医保'>
              <Checkbox
                checked={isProvinceInsuranceStatus}
                onChange={() => {
                  setIsProvinceInsuranceStatus(!isProvinceInsuranceStatus)
                }}
              >
                启用
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='' label='是否启用'>
              <Checkbox
                checked={status}
                onChange={() => {
                  setStatus(!status)
                }}
              >
                启用
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='' label='开通人脸识别'>
              <Checkbox
                checked={isFaceCall}
                onChange={() => {
                  setIsFaceCall(!isFaceCall)
                }}
              >
                启用
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='' label='开通人脸挂号'>
              <Checkbox
                checked={ybFaceRecognition}
                onChange={() => {
                  setYbFaceRecognition(!ybFaceRecognition)
                }}
              >
                启用
              </Checkbox>
            </Form.Item>
          </Col>

        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item name='limitPriceCfg' label='超限价处理方式'>
              <Select>
                <Option value={0}>仅提醒</Option>
                <Option value={1}>超出部分转现金</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='chinese25pcAlert' label='中药超进价25%提醒'>
              <Select>
                <Option value={0}>关</Option>
                <Option value={1}>开</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='skipFaceCallWhenYidi' label='异地患者跳过人脸识别'>
              <Select>
                <Option value={1}>跳过</Option>
                <Option value={0}>不跳过</Option>
              </Select>
            </Form.Item>
          </Col>
          {/*<Col span={10}>*/}
          {/*  <Form.Item name='chinese25pcConverted' label='中药超进价25%转自费'>*/}
          {/*    <Select defaultValue={0}>*/}
          {/*      <Option key={1} value={1}>开</Option>*/}
          {/*      <Option key={0} value={0}>关</Option>*/}
          {/*    </Select>*/}
          {/*  </Form.Item>*/}
          {/*</Col>*/}
        </Row>
      </Form>
    </Modal>
  )
}
